/**
 * Route for `customizable-dashboards`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CustomizableDashboardsPage } from "../features/customizable-dashboards/CustomizableDashboardsPage";

export const customizableDashboardsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/customizable-dashboards",
	component: CustomizableDashboardsPage,
});

export default customizableDashboardsRoute;
